import { useCallback } from 'react'
import * as React from 'react'

import type { IPatient } from '@app/domain/patient/patient.interface'
import type * as Patients from '@app/state/patients'

import { EditablePatientCard } from './editable-patient-card'
import { NoPatientCard } from './no-patient-card'
import { ReadOnlyPatientCard } from './read-only-patient-card'
import { SelectPatientCard } from './select-patient-card'

interface Props {
  isSelectPatientAllowed?: boolean
  onSelectPatient?: () => void
  patient?: IPatient
  onClearStatus?: () => void
  onUpdatePatient?: (id: string, patient: Patients.IApiUpdatePatient) => void
  updateStatus?: Patients.PatientActionStatusId
}

export const PatientCard = ({
  isSelectPatientAllowed,
  onSelectPatient,
  onUpdatePatient,
  patient,
  updateStatus,
}: Props) => {
  const [isEditable, setEditable] = React.useState(false)

  const handleCancelEdit = useCallback(() => {
    setEditable(false)
  }, [setEditable])

  const handleSetEditable = useCallback(() => {
    setEditable(true)
  }, [setEditable])

  const handleSelectPatient = useCallback(() => {
    if (onSelectPatient) {
      onSelectPatient()
    }
  }, [onSelectPatient])

  const handleUpdatePatient = useCallback(
    (id: string, patient: Patients.IApiUpdatePatient) => {
      onUpdatePatient(id, patient)
      setEditable(false)
    },
    [onUpdatePatient],
  )

  if (patient) {
    if (!isEditable) {
      return (
        <ReadOnlyPatientCard
          isSelectPatientAllowed={isSelectPatientAllowed}
          onSelectPatient={handleSelectPatient}
          onSetEditable={handleSetEditable}
          patient={patient}
          updateStatus={updateStatus}
        />
      )
    } else {
      return (
        <EditablePatientCard
          patient={patient}
          onCancelEdit={handleCancelEdit}
          onUpdatePatient={handleUpdatePatient}
          updateStatus={updateStatus}
        />
      )
    }
  } else if (isSelectPatientAllowed) {
    return <SelectPatientCard onSelectPatient={handleSelectPatient} />
  } else {
    return <NoPatientCard />
  }
}
